import { SET_RESOURCE_LIST } from '../constants/Resource';

const initState = {
  resourceList: []
};

const resource = (state = initState, action) => {
  switch (action.type) {
    case SET_RESOURCE_LIST:
      return {
        ...state,
        resourceList: action.resourceList
      };
    default:
      return state;
  }
};

export default resource;
